import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ApiServicesService } from '../services/api-services.service';
import { Router, RouterLink } from '@angular/router';
import { SnackbarService } from '../services/snackbar.service';


@Component({
  selector: 'app-online-member',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './online-member.component.html',
  styleUrl: './online-member.component.css'
})
export class OnlineMemberComponent {

  onlineMember: any = [];
  page: any = 1;
  limit: any = 9;
  profileComplete!: boolean;
  constructor(private apiService: ApiServicesService,private router: Router,private snackbarService: SnackbarService) { }

  ngOnInit(): void {
    this.getAllOnlineMembers();
  }

  getAllOnlineMembers() {
    this.apiService.getOnlineUsers(this.page, this.limit).subscribe({
      next: (data: any) => {
        this.onlineMember = data?.data?.users || [];
      },
      error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            // message: err.error.message,
            message: err.error.message=='Authorization Failed. Auth Token is Invalid'?'Logout':err.error.message,
            
            className: 'failed',
          }
        );
      }
    });
  }



  view_member(username: any) {
    const userdata = localStorage.getItem('encryptedUserData');
    if (userdata) {
      const decryptedData = this.apiService.decryptData(userdata);
      if (decryptedData && decryptedData.user) {
        this.profileComplete=decryptedData.user.profileCompleteness==1?true:false;
      }
    }

    if (this.profileComplete == true) {
      this.router.navigate(['/member-profile', username, 'Profile']);
    } else {
      this.snackbarService.openCustomSnackbar(
        {
          icon: false,
          message: 'Complete Your profile before using this feature',
          className: 'failed',
        }
      );
    }
  }



}
